import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=12f592bb&"
import script from "./FooterSection.vue?vue&type=script&lang=ts&"
export * from "./FooterSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports